export default "__VITE_ASSET__B1PRp7gn__"